import { useContext } from "react";
import { ContextProviderWrapper } from "../../../Context";
import { ActionConnect } from "../styled";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import balance_light from "../../../../assets/Dashboard/Common/balance_icon_light.svg";
import balance from "../../../../assets/Dashboard/Common/balance_icon.svg";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";

const ConnectWallet = ({ setOpenConfirmModal, chain }: any) => {
  const { open } = useAppKit();
  const { address } = useAppKitAccount();
  const { theme } = useContext(ContextProviderWrapper)!;
  const [tonConnectUI] = useTonConnectUI();
  const addressTon = useTonAddress();
  return (
    <ActionConnect
      className={theme}
      onClick={() => {
        if (chain === "Toncoin" && !addressTon) {
          tonConnectUI.openModal();
        } else if (addressTon || address) {
          setOpenConfirmModal(true);
        } else {
          open();
        }
      }}
    >
      {address || addressTon ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <figure>
            <img src={theme === "light" ? balance_light : balance} alt="icon" />
          </figure>
          {chain === "Toncoin" ? (
            <p>
              {addressTon.slice(0, 4)}...{addressTon.slice(-4)}
            </p>
          ) : (
            <p>
              {address && address.slice(0, 4)}...{address && address.slice(-4)}
            </p>
          )}
        </div>
      ) : (
        <>
          <figure>
            <img src={theme === "light" ? balance_light : balance} alt="icon" />
          </figure>
          <p>Connect Wallet</p>
        </>
      )}
    </ActionConnect>
  );
};

export default ConnectWallet;
